import React from "react";
import {
  Overlay,
  Modal,
  CloseButton,
  Title,
  Paragraph,
  Ornament,
  OrnLine,
  OrnDiamond,
  List,
  ListItem,
  Divider,
} from "./TermsAndConditionsModalStyles";

export default function TermsAndConditionsModal({ onClose }) {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const SectionTitle = ({ children }) => (
    <Paragraph
      as="h3"
      style={{
        fontWeight: 700,
        marginTop: "2rem",
        marginBottom: "0.75rem",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "rgba(0,0,0,0.82)",
      }}
    >
      {children}
    </Paragraph>
  );

  return (
    <Overlay onClick={handleOverlayClick}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>

        {/* ===================== */}
        {/* TERMENI SI CONDITII    */}
        {/* ===================== */}
        <Title>Termeni și Condiții</Title>
        <Ornament>
          <OrnLine />
          <OrnDiamond />
        </Ornament>

        <SectionTitle>Prevederi generale</SectionTitle>

        <Paragraph>
          <strong>1.1</strong> Website-ul – <strong>www.ahavacakes.ro</strong>{" "}
          („Website-ul”) este proprietatea{" "}
          <strong>S.C. VIBE’ART MARROX SOLUTION SRL</strong>, societate juridică
          de naţionalitate română, înregistrată la Oficiul Registrului
          Comerţului sub nr. <strong>J2017000733029</strong>, având Cod Unic de
          Înregistrare <strong>RO34829837</strong>, cu sediul social în{" "}
          <strong>Arad</strong>,{" "}
          <strong>
            str. Elena Ghiba Birta nr 6-8, apartament 6, Demisol, jud. Arad
          </strong>
          , denumită pe parcursul acestor Termene și Condiții,{" "}
          <strong>“Ahava Cakes”</strong>.
        </Paragraph>

        <Paragraph>
          <strong>1.2</strong> Comercializarea Produselor prin intermediul
          Website-ului – Produsele (“Produse“) oferite sunt cele enumerate în
          catalogul publicat pe Website, în limita stocurilor disponibile.
          Produsele pe care Ahava Cakes le oferă Clienților săi sunt realizate
          la standarde ridicate de calitate. Ahava Cakes este specializată în
          realizarea și vânzarea mai multor tipuri de prăjitură –{" "}
          <strong>
            ChocoAmour, Bucureșți Élégance, Étoile, Polar Bliss, Ruby Doboș,
            D’or Pavlova, Velour Vanille, Coconut, Choux de Rêve, Éclair
            Prestige, Gâteau Noir, Velour Rouge, Émeraude, Éclat de Fruits,
            Macaron d’Amour, Muffeline, Verrine Élégance, cookies, bezele,
            negresă, platouri cu prăjitură asortată, produse de patiserie
          </strong>{" "}
          și alte tipuri de torture și cutii cadou. Ahava Cakes este un brand
          românesc, în care îmbinăm tradiția și inovația, adaptăm rețete clasice
          tehnicilor moderne, pentru a rezultă un produs unic și de o calitate
          remarcabilă.
        </Paragraph>

        <Paragraph>
          <strong>1.3</strong> Utilizatorul Website-ului este:
        </Paragraph>
        <List>
          <ListItem>
            Persoană fizică, în vârstă de cel puțîn 18 ani, cu capacitate de
            exercițiu deplină;
          </ListItem>
          <ListItem>
            Orice reprezentant al unei persoane juridice înmatriculate și
            funcționând în conformitate cu legile din România, acționând în
            numele și pe seama persoanei juridice;
          </ListItem>
          <ListItem>
            Orice persoană fizică autorizată (PFA), care accesează, comandă sau
            achiziționează Produse prin intermediul Website-ului, denumită pe
            parcursul acestor Termene și Condiții “Client”.
          </ListItem>
        </List>

        <Paragraph>
          <strong>1.4</strong> Aria de aplicare a Termenelor și Condițiilor –
          Termenele și Condițiile definesc condițiile de utilizare a
          Website-ului și condițiile contractuale ce guvernează relația dintre
          Ahava Cakes și Client. Prin acceptarea Termenelor și Condițiilor,
          Clientul este de acord că:
        </Paragraph>
        <List>
          <ListItem>
            În cazul în care Clientul este o persoană fizică, acesta acționează
            în nume propriu și nu reprezintă nicio altă persoană, iar dacă este
            reprezentantul unei persoane juridice, acționează în limitele
            împuternicirii ce i-a fost acordată;
          </ListItem>
          <ListItem>
            Clientul va furniza informații corecte și complete în vederea
            utilizării Website-ului;
          </ListItem>
          <ListItem>
            Clientul nu va utiliza Website-ul pentru a reproduce, duplică,
            copia, vinde, revinde, distribui, publică sau exploata, în niciun
            scop comercial, software-ul, conținutul, ofertele, produsele sau
            serviciile furnizate de către Ahava Cakes, sau obținute prin
            intermediul Website-ului fără să obțînă consimțământul expres,
            prealabil și scris al Ahava Cakes. Această restricție include orice
            încercare de a încorpora orice informație de pe Website în orice alt
            catalog, produs sau serviciu;
          </ListItem>
          <ListItem>
            Clientul nu va utiliza Website-ul în niciun mod care ar putea să
            afecteze în mod negativ disponibilitatea resurselor sale sau
            utilizarea să de către alți Clienți sau în orice mod care ar putea
            defectă, dezactiva, supraîncărca sau deteriora serverele sau
            rețelele Ahava Cakes sau ale unor terțe persoane;
          </ListItem>
          <ListItem>
            Clientul nu va utiliza Website-ul în orice scop care este ilegal sau
            interzis prin aceste Termene și Condiții sau prin alte politici
            relevante.
          </ListItem>
        </List>

        <Paragraph>
          <strong>1.5</strong> Acceptarea Termenelor și Condițiilor – Prin
          accesarea și utilizarea Website-ului, Clientul ia cunoștință de și
          acceptă prezențele Termene și Condiții, precum și celelalte politici
          relevante pentru Website. Pentru folosirea în bune condiții a
          Website-ului, Clientul are obligăția de a citi cu atenție și de a
          respectă Termenele și Condițiile, precum și orice alte politici
          relevante ale Website-ului, așa cum acestea sunt afișate pe Website
          sau vor fi notificate Clientului la un anumit moment.
        </Paragraph>

        <Paragraph>
          <strong>1.6</strong> Modificarea Termenelor și Condițiilor – Ahava
          Cakes își rezervă dreptul de a modifică unilateral în orice moment
          Termenele și Condițiile, precum și orice alte politici relevante.
          Continuarea folosirii Website-ului în orice fel, inclusiv prin
          comandarea și achiziționarea de Produse, ulterior modificării
          Termenelor și Condițiilor reprezintă acceptul Clientului cu privire la
          modificările efectuate. Termenele și Condițiile modificate vor fi
          aplicate oricărei comenzi/tranzacții începând cu ziua modificării
          acestora. Ultima actualizare a Termenelor și Condițiilor a fost
          efectuată în dată de: <strong>30.10.2025</strong>.
        </Paragraph>

        <Paragraph>
          <strong>1.7</strong> Accesibilitatea Website-ului – Website-ul este
          accesibil clienților 24 de ore din 24, 7 zile din 7 în afară cazurilor
          în care se efectuează operațiuni de mentenanță. Ahava Cakes își
          rezervă dreptul de a întrerupe unilateral accesul la Website (integral
          sau parțial), în orice moment, cu notificarea imediată a
          utilizatorilor, prin mesaj afișat pe Website la momentul accesării.
          Ahava Cakes nu poate fi ținută răspunzătoare față de Client și/sau
          față de terțe persoane pentru lipsa de funcționalitate sau pentru
          funcționarea neconformă a Website-ului.
        </Paragraph>

        <Divider />

        <SectionTitle>Utilizarea Website-ului</SectionTitle>

        <SectionTitle>2.1 Crearea unui Cont de către Client</SectionTitle>
        <Paragraph>
          Pentru efectuarea de cumpărături prin intermediul Website-ului,
          Clientul are posibilitatea de a achiziționa Produse fără a avea un
          cont pe Website, sau poate alege să își creeze un astfel de cont,
          pentru a facilita comenzile viitoare de pe Website. În cazul în care
          Clientul alege să își creeze un cont, acesta se va realiza urmând
          instrucțiunile din secțiunea ”Creează cont”.
        </Paragraph>

        <Paragraph>
          Clientul este responsabil pentru menținerea confidențialității datelor
          asociate contului său creat pe Website. Datele solicitate de către
          Ahava Cakes la momentul realizării contului de către Client sunt
          necesare pentru gestionarea comenzilor și a relațiilor comerciale
          dintre Ahava Cakes și Client. Parolă nu va fi folosită pentru
          efectuarea de plăți online, această va fi folosită doar în scopul
          înregistrării Clientului și creării unui Cont în vederea efectuării
          comenzilor online.
        </Paragraph>

        <Paragraph>
          Clienții sunt obligăți să furnizeze date adevărate, exacte și complete
          așa cum este indicat și în formularul de înregistrare și să
          reînnoiască, ori de câte ori este necesar, datele de înregistrare
          pentru a fi adevărate, exacte și complete în orice moment. În cazul
          furnizării de către Client a unor informații care nu sunt conforme cu
          realitatea, inexacte sau incomplete, Ahava Cakes își rezervă dreptul
          de a suspendă sau desființa contul și de a refuză toate încercările
          curente sau viitoare de folosire a serviciilor Website-ului, fără
          nicio despăgubire față de Client.
        </Paragraph>

        <Paragraph>
          Aceste condiții sunt necesar a fi îndeplinite și în cazul
          înregistrării participării Clienților la Concursurile/Promoțiile
          organizate și prezentate în cadrul Website-ului de către Ahava Cakes,
          Concursuri/Promoții ce vor fi guvernate de regulamente distincte.
        </Paragraph>

        <Paragraph>
          Clientul este în întregime responsabil pentru menținerea securității
          și confidențialității contului și a parolei și este responsabil pentru
          toate activitățile și conduită să sau a oricărei alte persoane care
          efectuează comenzi de Produse prin intermediul contului.
        </Paragraph>

        <Paragraph>
          Clientul este de acord să notifice Ahava Cakes imediat cu privire la
          orice suspiciune de utilizare neautorizată a contului său și cu
          privire la orice suspiciune legată de o posibilă breșă de securitate.
          Ahava Cakes sau reprezentanții săi nu vor fi responsabili pentru nicio
          pierdere sau prejudiciu, de orice fel, care ar putea surveni că urmare
          a utilizării, de către o altă persoană, a contului, cu sau fără
          permisiunea Clientului. Clientul este răspunzător pentru orice
          pierderi cauzate Ahava Cakes sau oricărei terțe părți că urmare a
          utilizării Contului de către o altă persoană.
        </Paragraph>

        <Paragraph>
          În cazul nerespectării de către Client a Termenelor și Condițiilor sau
          a oricăror altor politici relevante, Ahava Cakes își rezervă dreptul
          de a dezactiva contul Clientului, fără nicio despăgubire și fără
          acordarea unui preaviz sau a vreunei alte formalități, după
          înștiințarea Clientului printr-un e-mail. În caz de fraudă sau
          încălcarea oricăror legi aplicabile din partea Clientului,
          dezactivarea contului se va face fără preaviz, fără înștiințare, fără
          alte formalități și fără despăgubiri, Ahava Cakes procedând exclusiv
          la informarea Clientului printr-un e-mail.
        </Paragraph>

        <Paragraph>
          În cazul pierderii sau uitării parolei, această poate fi regenerată
          accesând căsuța „Contul meu” și introducând adresa de e-mail, urmând
          că o parolă să fie transmisă prin e-mail. Parolă este strict
          confidențială.
        </Paragraph>

        <Paragraph>
          Clientul care dorește dezactivarea contului său are posibilitatea să
          efectueze această acțiune urmând instrucțiunile din Website, secțiunea
          ”Contul meu” sau scriindu-ne pe adresa{" "}
          <strong>office@ahavacakes.ro</strong>. Contul nu poate fi dezactivat
          între momentul plasării unei comenzi și ridicarea acelei comenzi. În
          situația în care un Client dorește să plaseze o comandă pe Website
          fără a se înregistra prin crearea unui cont, va putea efectua acest
          lucru prin introducerea datelor solicitate de către Website în
          momentul plasării comenzii.
        </Paragraph>

        <SectionTitle>
          2.2 Produsele Ahava Cakes oferite spre comercializare
        </SectionTitle>
        <Paragraph>
          Fiecare tip de Produs oferit spre vânzare pe Website este însoțit de o
          descriere a acestuia, permițând Clientului să ia cunoștință de
          informațiile esențiale cu privire la caracteristicile acestuia înainte
          de a finaliza o comandă. Imaginile folosite pentru descrierea
          Produselor pe Website nu reprezintă o obligăție contractuală din
          partea Ahava Cakes, acestea fiind utilizate exclusiv cu titlu de
          prezentare.
        </Paragraph>

        <Paragraph>
          Informațiile afișate pe Website au doar scop informativ și nu sunt
          destinate să înlocuiască sfatul unor specialișți din diverse domenii
          (de exemplu, nutriție).
        </Paragraph>

        <SectionTitle>
          2.3 Disponibilitatea Produselor și valabilitatea ofertelor
        </SectionTitle>
        <Paragraph>
          Ofertele de Produse și prețurile afișate pe Website sunt valabile atât
          timp cât sunt vizibile pe Website și în limita stocului disponibil.
          Produsele și ofertele valabile vor fi semnalizate pe Website prin
          prezența butonului „Adaugă în coș”/”Click & Collect”, în dreptul
          acestora.
        </Paragraph>

        <SectionTitle>2.4 Prețurile Produselor</SectionTitle>
        <Paragraph>
          Prețurile Produselor prezentate pe Website sunt exprimate în LEI și au
          toate taxele incluse. Prețurile aplicabile sunt cele afișate pe
          Website în momentul validării comenzii de către Client. În cazul în
          care Produsele din coșul de cumpărături vor suferi modificări ale
          prețurilor, noile prețuri vor fi semnalizate Clientului înainte de
          finalizarea comenzii. Prețurile includ T.V.A., iar toate modificările
          legale survenite cu privire la cuantumul acestei taxe se vor reflectă
          în prețul Produselor prezente pe Website în momentul întrării în
          vigoare a actului normativ respectiv.
        </Paragraph>

        <SectionTitle>
          2.5 Plasarea Comenzii și încheierea contractului de vânzare
        </SectionTitle>
        <Paragraph>
          Efectuarea de comenzi tip click & collect prin intermediul
          Website-ului se poate realiza național pentru toate produsele listate
          pe Website, însă noi nu livrăm produsele, ci clienți sunt rugați să le
          ridice personal sau prin terțe persoane.
        </Paragraph>

        <Paragraph>
          Pentru a evita orice dubiu, în prezent, livrarea produselor Ahava
          Cakes nu este disponibilă, fiind disponibilă numai metoda de
          click&collect.
        </Paragraph>

        <Paragraph>
          În vederea efectuării și înregistrării unei comenzi, Clientul trebuie
          să urmeze instrucțiunile afișate pe Website în acest sens. În momentul
          dinaintea validării comenzii, Clientului i se va pune la dispoziție un
          recapitulativ al informațiilor legate de comandă: numărul de articole
          comandate, dată, magazinul Ahava Cakes din care a solicitat ridicarea
          produselor, intervalul orar ales, precum și totalul de plată. Comandă
          se validează printr-un “click” pe butonul “PLATĂ ONLINE”.
        </Paragraph>

        <Paragraph>
          Prin validarea comenzii, Clientul acceptă că această comandă implică o
          obligăție de a plăți și își dă acordul cu privire la acceptarea
          prezențelor Termene și Condiții.
        </Paragraph>

        <Paragraph>
          Comenzile nevalidate prin accesarea butonului ”PLATĂ ONLINE” și prin
          finalizarea plății nu vor fi onorate. Simplul fapt de a adăuga Produse
          în coșul de cumpărături nu echivalează cu validarea comenzii și nu
          creează nicio obligăție pentru Ahava Cakes de a proceda la furnizarea
          Produselor către Client.
        </Paragraph>

        <Paragraph>
          Ahava Cakes confirmă înregistrarea comenzii printr-un e-mail automat
          trimis către Client, prin intermediul căruia i se vor comunica
          următoarele informații: lista cu articolele comandate, prețurile
          Produselor, magazinul Ahava Cakes din care Clientul a solicitat
          ridicarea comenzii, intervalul orar ales, precum și factură pentru
          Produsele comandate. În acest caz, contractul de vânzare se va
          consideră a fi încheiat la dată primirii, de către Client, a
          confirmării înregistrării comenzii.
        </Paragraph>

        <Paragraph>
          Ahava Cakes poate solicită informații suplimentare despre comandă,
          fără limitare, în cazul în care informațiile furnizate inițial de
          către Client nu sunt suficiente pentru onorarea comenzii. În acest
          caz, comandă va fi validată și contractul de vânzare va fi considerat
          încheiat doar la dată primirii noilor informații solicitate. În cazul
          nefurnizării de către Client a informațiilor suplimentare solicitate,
          contractul de vânzare nu va fi considerat că fiind valabil încheiat,
          Ahava Cakes neavând obligăția de a onora comandă respectivă.
        </Paragraph>

        <Paragraph>
          Pentru comenzile efectuate prin intermediul Website-ului pentru care
          Clientul optează să le ridice personal din magazinele Ahava Cakes
          indicate, nu există o valoare minimă de comandă.
        </Paragraph>

        <Paragraph>
          Condițiile pentru plasarea comenzilor sunt următoarele:
        </Paragraph>
        <List>
          <ListItem>
            Pentru a ne asigura că fiecare deșert este pregătit cu grijă și
            atenție la detalii, vă rugăm să respectăți termenele de comandă.
          </ListItem>
          <ListItem>
            Torturile din colecția Ahava Cakes – se comandă cu minimum{" "}
            <strong>48 ore</strong> înainte de dată dorită pentru ridicare.
          </ListItem>
          <ListItem>
            Torturile personalizate (decoruri speciale, tematici, mesaje unice)
            – necesită un timp de pregătire mai mare și se comandă cu minimum{" "}
            <strong>5 zile</strong> înainte.
          </ListItem>
          <ListItem>
            Fiecare tort este realizat artizanal, cu ingrediente naturale, de
            aceea timpul de pregătire este esențial pentru calitatea și
            frumusețea produsului final.
          </ListItem>
        </List>

        <Paragraph>Comenzile pot fi plasate:</Paragraph>
        <List>
          <ListItem>telefonic / WhatsApp,</ListItem>
          <ListItem>prin formularul de comandă de pe website,</ListItem>
          <ListItem>direct la gemuletul laboratorului Ahava Cakes.</ListItem>
        </List>

        <Paragraph>
          Vă recomandăm să plasați comenzile din timp, mai ales pentru perioade
          aglomerate (sărbători, evenimente speciale), pentru a vă asigura că
          putem onora cererea.
        </Paragraph>

        <Paragraph>
          <strong>Notă:</strong> Toate deserturile Ahava Cakes sunt proaspete și
          artizanale, realizate fără premixuri. Stocurile sunt limitate și se
          actualizează permanent. Clientul are posibilitatea de a urmări
          statusul comenzilor sale plasate pe Website, precum și istoricul
          tranzacțiilor efectuate accesând rubrica „Contul meu”.
        </Paragraph>

        <SectionTitle>2.6 Plata Produselor</SectionTitle>
        <Paragraph>
          Plata comenzilor realizate se poate efectua în următoarele modalități:
        </Paragraph>
        <List>
          <ListItem>Plata online prin card bancar.</ListItem>
        </List>

        <Paragraph>
          Toate tranzacțiile bancare de pe Website vor fi efectuate într-o
          manieră securizată, procesatorul de plăți fiind garantul acestei
          securități din punct de vedere al efectuării plăților online și se
          obligă să protejeze toate datele și informațiile personale ce au
          legătură cu modalitățile de plată online, și să le păstreze, doar dacă
          este cazul.
        </Paragraph>

        <Paragraph>
          Suma de plată pentru comandă validată va fi blocată de pe cardul valid
          înregistrat de către Client în momentul validării comenzii respective.
          Suma plătită efectiv pentru comandă va fi retrasă în momentul în care
          tranzacția este procesată de către instituția financiar-bancară
          responsabilă și nu poate fi mai mare decât suma blocată inițial în
          momentul validării comenzii.
        </Paragraph>

        <Paragraph>
          Clientul garantează Ahava Cakes că utilizarea mijlocului de plată ales
          nu încalcă nicio lege aplicabilă. Ahava Cakes își rezervă dreptul de a
          suspendă/anula orice comandă asupra căreia există suspiciuni cu
          privire la vreo acțiune ilegală sau frauduloasă privind modalitatea de
          plată. Ahava Cakes își rezervă dreptul de a suspendă/anula toate
          comenzile în cazul refuzului efectuării plății de către instituțiile
          financiar-bancare, fără nicio despăgubire sau notificare față de
          Client.
        </Paragraph>

        <Paragraph>
          Toate informațiile introduse în vederea efectuării unei plăți online
          (numărul cadrului, parolă, dată validității cardului) nu vor fi
          stocate pe serverele Ahava Cakes, ci vor fi procesate exclusiv de
          către unitățile bancare emitente ale cardurilor.
        </Paragraph>

        <Paragraph>
          Pentru comenzile plasate pe Website se va emite automat Factură
          fiscală, această înlocuind Bonul fiscal. Factură fiscală aferentă unei
          comenzi online va fi emisă în format electronic și va fi trimisă pe
          e-mail. Clientul va putea descărca și tipări Factură fiscală atașată
          în e-mail.
        </Paragraph>

        <Paragraph>
          În cazul în care un Produs comandat de către Client nu poate fi livrat
          din motive independente de voința Ahava Cakes, Clientul va fi informat
          în acest sens și i se va returna în contul bancar contravaloarea
          produsului, în termen de maxim 14 zile de la dată la care Ahava Cakes
          a luat cunoștință de acest fapt.
        </Paragraph>

        <SectionTitle>2.7 Ridicarea produselor</SectionTitle>
        <Paragraph>
          Clientul are posibilitatea de a opta între următoarele metode:
        </Paragraph>
        <List>
          <ListItem>
            Ridicarea Produselor de la punctul de lucru indicat de către Client
            în momentul efectuării comenzii – pentru toate produsele de pe
            website.
          </ListItem>
        </List>

        <Paragraph>
          Ahava Cakes se angajează să răspundă tuturor cererilor și
          reclamațiilor în cel mult 5 zile lucrătoare de la primirea acestora,
          exclusiv comenzilor, unde timpul de răspuns este unul adecvat timpului
          de producție și ridicare (pentru încadrarea în 48 de ore, respectiv 5
          zile).
        </Paragraph>

        <Paragraph>
          În ipoteza în care dată și intervalul orar de ridicare comandă
          selectate de către Client nu vor putea fi respectate, Clientul va fi
          imediat informat prin toate mijloacele puse la dispoziție de către
          Client.
        </Paragraph>

        <Paragraph>
          În caz de întârziere a ridicării Produselor comandate, Ahava Cakes
          sfătuiește Clientul să anunțe această întârziere contactându-ne la
          numărul de telefon <strong>0775 107 107</strong> pentru a putea găși
          soluția optimă în vederea ridicării produselor în timp util.
        </Paragraph>

        <SectionTitle>2.8 Dreptul de retragere</SectionTitle>
        <Paragraph>
          La recepționarea comenzii, Clientul trebuie să se asigure că Produsele
          corespund din punct de vedere calitativ și cantitativ așteptărilor
          sale. În caz contrar, Clientul poate să atenționeze Ahava Cakes
          apelând numărul de telefon <strong>0775 107 107</strong> sau prin
          e-mail la adresa <strong>office@ahavacakes.ro</strong> în cel mai
          scurt timp pentru a remedia situația creată.
        </Paragraph>

        <Paragraph>
          Potrivit prevederilor OUG nr. 34/2014, dreptul de retragere nu se
          aplică contractelor având drept obiect furnizarea de Produse care sunt
          susceptibile a se deteriora sau a expiră rapid. Prin urmare, Clientul
          nu are dreptul să se retragă din Contract, respectiv să returneze sau
          să refuze să recepționeze un Produs comandat.
        </Paragraph>

        <Divider />

        <SectionTitle>Relația cu clienții</SectionTitle>
        <Paragraph>
          Pentru orice informație sau reclamație referitoare la Website sau la
          comenzi, Clienții au la dispoziție următoarele date de contact:
        </Paragraph>
        <List>
          <ListItem>
            Numărul de telefon <strong>0775 107 107</strong>
          </ListItem>
          <ListItem>
            Adresa de e-mail <strong>office@ahavacakes.ro</strong>
          </ListItem>
        </List>

        <Divider />

        <SectionTitle>Protecția datelor cu caracter personal</SectionTitle>
        <Paragraph>
          Ahava Cakes colectează, prin intermediul Website-ului, datele cu
          caracter personal ale Clientului. Clientul trebuie să consulte
          Politică de Confidențialitate aplicabilă Website-ului la Politică de
          confidențialitate. Website-ul utilizează Cookies. Prin utilizarea
          Website-ului, Clientul este de acord cu Politică Cookies.
        </Paragraph>

        <Divider />

        <SectionTitle>Proprietate intelectuală</SectionTitle>
        <Paragraph>
          Conținutul Website-ului este protejat de legile privind drepturile de
          proprietate intelectuală aplicabile, inclusiv dar fără a se limita la
          Legea nr. 8/1996 privind drepturile de autor și drepturile conexe.
          Toate textele, formatările (inclusiv, fără a se limita selectarea,
          coordonarea și aranjarea materialelor pe Website) și imaginile,
          graficele, animațiile, instrumentele, aplicățiile, muzică, sunetele,
          articolele, copiile, materialele, fotografiile, mărcile, denumirile
          comerciale și logourile, precum și alte materiale și informațîi de pe
          acest Website sunt protejate de drepturi de proprietate intelectuală
          ale Ahava Cakes, subsidiarilor și afiliaților, și ale licențiatorilor
          acestora (denumite în mod colectiv ”Conținutul”).
        </Paragraph>

        <Paragraph>
          Aceste materiale nu pot fi copiate, supuse unor operațiuni de
          inginerie inversă, decompilate, dezasamblate, modificate, publicate pe
          alte website-uri, încadrate, schimbate sau distribuite, redistribuite,
          licențiate, sub-licențiate sau transferate în orice formă de către
          Client. Niciunul dintre elementele de pe Website nu va fi considerat a
          acordă direct, implicit, sau în orice alt mod, orice licență sau drept
          de a utiliza, în orice scop Conținutul, în tot sau în parte. Mărcile,
          logourile, numele comerciale și mărcile, atât înregistrate cât și
          neînregistrate (denumite, în mod colectiv, ”Mărcile”) afișate pe
          Website sunt Mărci aparțînând Ahava Cakes sau terților parteneri
          afiliați ai acestora. Nimic de pe Website nu trebuie interpretat că
          acordând, în mod direct, implicit, sau în alt mod, orice licență sau
          drept de utilizare a oricărei Mărci afișate pe Website.
        </Paragraph>

        <Paragraph>
          Clientul declară și înțelege că orice utilizare neautorizată a acestor
          materiale reprezintă încălcarea drepturile de proprietate intelectuală
          ale Ahava Cakes sau terților parteneri afiliați ai acestora și va
          atrage exercitarea de către aceștia a tuturor remediilor legale.
        </Paragraph>

        <Paragraph>
          Ahava Cakes oferă Clientului o licență limitată, neexclusivă,
          revocabilă pentru a vedea, distribui, printa sau descărca orice
          Conținut, așa cum acesta este definit mai sus, de pe Website, pentru
          uzul său personal. Clientului nu îi este acordat dreptul să
          licențieze, republice, distribuie, copieze, cesioneze, sub-licențieze,
          transfere, vândă, creeze opere derivate sau orice altă utilizare
          non-personală a oricărui Conținut al Website-ului. Nicio parte a
          Conținutului nu poate fi reprodusă în nicio formă sau încorporată în
          orice sistem electronic sau mecanic de găsire a informațiilor, altfel
          decât în scopul folosirii personale. Clientul nu poate accesa sau
          utiliza Website-ul în niciun fel care ar putea sau care are scopul de
          a dăuna sau afecta Website-ul sau orice server sau rețea care stă la
          baza Website-ului, ori de a interfera cu utilizarea și dreptul
          oricărei alte persoane sau entități de a utiliza Website-ul.
        </Paragraph>

        <Divider />

        <SectionTitle>Alte prevederi</SectionTitle>
        <Paragraph>
          Website-ul poate conține legături („Link-uri”) sau trimiteri către
          alte website-uri/pagini web pentru utilizarea cărora se vor aplică
          Termene și Condițîi de utilizare specifice, astfel cum sunt acestea
          specificate pe website-urile/paginile respective, Ahava Cakes nefiind
          răspunzătoare și neasumându-și nicio obligație pentru conținutul
          respectivelor website-uri și/sau cu privire la orice alte legături sau
          trimiteri din acestea către alte website-uri sau pagini web.
          Includerea acestor Link-uri sau trimiteri pe Website este realizată,
          de regulă, pentru ajutorul sau în interesul Clientului, iar în alte
          cazuri în scop publicitar. Ahava Cakes nu garantează/controlează
          actualitatea/exactitatea informațiilor prezente pe website-urile unor
          terți către care trimit Link-urile de pe Website. Prin continuarea
          utilizării Website-ului, Clientul înțelege și acceptă că accesează
          acele website-uri și/sau folosește produsele/serviciile oferite prin
          intermediul acestora, exclusiv pe propriul risc și pe propria
          răspundere și că Ahava Cakes nu este răspunzător pentru prejudiciile
          suferite că urmare a accesării acestor Link-uri și folosirii
          serviciilor puse la dispoziție pe website-urile către care Link-urile
          fac trimitere.
        </Paragraph>

        <Divider />

        <SectionTitle>Despăgubiri</SectionTitle>
        <Paragraph>
          Clientul declară și recunoaște că este de acord să despăgubească,
          apere și să exonereze de orice responsabilitate, pierdere, solicitare
          și cheltuială, Ahava Cakes și partenerii săi contractuali și
          funcționarii, directorii, angajațîi și afiliațîi acestora, inclusiv
          dar fără a se limita la, taxe și costuri rezonabile aferente
          avocaților în legătură cu sau rezultând din: (i) încălcarea acestor
          Termene și Condițîi de către Utilizator, sau a oricăror alte politici
          relevante, în special cele privind confidențialitatea; (ii) utilizarea
          necorespunzătoare a Website-ului de către Client; (iii) nerespectarea
          sau încălcarea drepturilor de autor sau a altor drepturi de
          proprietate intelectuală sau a altor drepturi ale unor terțe părți
          prin încălcarea clauzei – Proprietate Intelectuală – din aceste
          Termene și Condiții.
        </Paragraph>

        <Paragraph>
          Ahava Cakes va despăgubi Clientul pentru prejudiciul direct creat că
          urmare a: (i) încălcării acestor Termene și Condițîi, (îi) acțiunilor
          culpabile săvârșite cu intenție sau neglijență gravă de către propriii
          angajați. În aceste două cazuri, se vor aplică prioritar remediile
          prevăzute de prezențele Termene și Condițîi.
        </Paragraph>

        <Divider />

        <SectionTitle>Forța majoră</SectionTitle>
        <Paragraph>
          Toate evenimentele de forță majoră definite de legislația română
          reprezintă un motiv de suspendare și stingere a obligațiilor Ahava
          Cakes. Niciuna dintre părți nu va fi răspunzătoare pentru neexecutarea
          obligațiilor sale decurgând din aceste Termene și Condițîi, dacă o
          astfel de neexecutare la termen și/sau în mod corespunzător, total sau
          parțial este datorată unui eveniment de forță majoră. Forţa majoră
          este orice eveniment extern, imprevizibil, absolut invincibil şi
          inevitabil. Dacă în termen de 15 (cincisprezece) zile de la dată
          producerii lui, respectivul eveniment nu încetează, fiecare parte va
          avea dreptul să notifice celeilalte părți anularea comenzii, fără că
          vreuna dintre ele să poată pretinde celeilalte alte daune-interese.
          Ahava Cakes nu poate fi tras la răspundere în aceste cazuri de forță
          majoră.
        </Paragraph>

        <Divider />

        <SectionTitle>Reclamații și litigii</SectionTitle>
        <Paragraph>
          Aceste Termene și Condițîi sunt supuse legislației din România. În caz
          de apariție a unor dispute, Clientul va putea să depună reclamațîi la
          adresa de e-mail <strong>office@ahavacakes.ro</strong> pentru a ajunge
          la o soluționare amiabilă. Însă, în condițiile în care nu s-a ajuns la
          o înțelegere amiabilă între părți, litigiile vor fi soluționate de
          instanțele judecătorești competențe.
        </Paragraph>

        <Paragraph>
          Prin utilizarea Website-ului vă exprimați în mod expres acordul cu
          privire la următoarele prevederi ale acestor TERMENE ȘI CONDIȚII:
        </Paragraph>
        <List>
          <ListItem>PREVEDERI GENERALE;</ListItem>
          <ListItem>UTILIZAREA WEBSITE-ULUI;</ListItem>
          <ListItem>PROPRIETATE INTELECTUALĂ;</ListItem>
          <ListItem>DESPĂGUBIRI;</ListItem>
          <ListItem>RECLAMAȚII ȘI LITIGII;</ListItem>
          <ListItem>ALTE PREVEDERI.</ListItem>
        </List>

        <Divider />

        {/* ===================== */}
        {/* POLITICA CONFIDENTIALITATE */}
        {/* ===================== */}
        <Title>Politica de Confidențialitate</Title>
        <Ornament>
          <OrnLine />
          <OrnDiamond />
        </Ornament>

        <SectionTitle>
          I. Scopul Politicii de confidențialitate și alte informații generale
        </SectionTitle>
        <Paragraph>
          Conţinutul website-ului <strong>www.ahavacakes.ro</strong> (denumit în
          continuare „Website-ul”) este proprietatea{" "}
          <strong>S.C. VIBE’ART MARROX SOLUTION SRL</strong>, societate juridică
          de naţionalitate română, înregistrată la Oficiul Registrului
          Comerţului sub nr. <strong>J2017000733029</strong>, având Cod Unic de
          Înregistrare <strong>CUI RO34829837</strong>, cu sediul în{" "}
          <strong>
            Arad, str. Elena Ghiba Birta nr 6-8, apartament 6, Demisol, jud.
            Arad
          </strong>
          , denumită pe parcursul acestor Termene și Condiții, “Ahava Cakes”,
          (denumită în continuare “Ahava Cakes” sau “Titularul”).
        </Paragraph>

        <Paragraph>
          În calitate de operator de date, Ahava Cakes urmărește în permanență
          şi se asigură că prelucrarea datelor cu caracter personal respectă cu
          stricteţe principiile şi legislaţia privind protecția datelor cu
          caracter personal, în particular prevederile Regulamentului (UE)
          2016/679 privind protecţia persoanelor fizice în ceea ce priveşte
          prelucrarea datelor cu caracter personal şi libera circulaţie a
          acestor date şi de abrogare a Directivei 95/46/CE (în continuare
          “RGPD”).
        </Paragraph>

        <Paragraph>
          Politica de confidențialitate are rolul de a vă informa cu privire la
          modul în care Ahava Cakes prelucrează datele dumneavoastră cu caracter
          personal atunci când vizitați Website-ul nostru, când utilizați
          funcțiile disponibile în cadrul Website-ului, când ne trimiteți
          comenzi sau alte cereri pe e-mail.
        </Paragraph>

        <Paragraph>
          Această Politică de confidențialitate poate fi actualizată ulterior,
          caz în care vă vom informa prin publicarea pe Website a versiunii
          actualizate. Pentru a vă asigura că sunteți informat în mod permanent
          cu privire la modul în care Ahava Cakes vă prelucrează datele cu
          caracter personal, puteți consulta Politica de confidențialitate de
          fiecare dată când reveniți pe Website-ul nostru sau când utilizați
          funcțiile disponibile pe acesta.
        </Paragraph>

        <Paragraph>
          Website-ul poate include Link-uri către alte website-uri care sunt
          gestionate de alte entități/persoane juridice cu privire la care Ahava
          Cakes nu este responsabil și care nu au legătură cu activitatea
          noastră. Atunci când accesați aceste website-uri prin intermediul
          Website-ului nostru, vă recomandăm să consultați politicile de
          confidențialitate ale acelor website-uri pentru a fi informați cu
          privire la modul în care datele dumneavoastră cu caracter personal
          sunt prelucrate de către titularii acelori website-uri.
        </Paragraph>

        <SectionTitle>
          II. Termenii utilizați și definiţiile acestora
        </SectionTitle>
        <List>
          <ListItem>
            <strong>„Client”</strong> înseamnă persoana fizică sau juridică ce
            achiziţionează unul sau mai multe Produse, prin plasarea unei
            comenzi pe Website-ul Ahava Cakes.
          </ListItem>
          <ListItem>
            <strong>„Date cu Caracter Personal”</strong> înseamnă orice
            informații privind o persoană fizică identificată sau identificabilă
            („persoana vizată”); o persoană identificabilă este o persoană care
            poate fi identificată, direct sau indirect, în special prin referire
            la un element de identificare, cum ar fi un nume, un număr de
            identificare, date de localizare, un identificator online, sau la
            unul sau mai multe elemente specifice, proprii identității sale
            fizice, fiziologice, genetice, psihice, economice, culturale sau
            sociale.
          </ListItem>
          <ListItem>
            <strong>„Prelucrare“</strong> (și derivatele sale, incluzând fără
            limitare ”a prelucra”) înseamnă orice operaţiune sau set de
            operațiuni efectuate asupra Datelor cu Caracter Personal, incluzând
            fără limitare colectarea, înregistrarea, păstrarea, modificarea,
            utilizarea, dezvăluirea, accesul, transferul sau distrugerea
            acestora.
          </ListItem>
          <ListItem>
            <strong>„Utilizator”</strong> înseamnă orice persoană care accesează
            sau utilizează Website-ul.
          </ListItem>
          <ListItem>
            Ceilalţi termeni utilizaţi cu majusculă şi care nu au fost definiţi
            în cuprinsul prezentei Politici de confidenţialitate, vor avea
            înţelesul atribuit potrivit definiţiilor din Termenele şi Condiţiile
            de utilizare a Website-ului.
          </ListItem>
        </List>

        <SectionTitle>
          III. În ce scopuri vă prelucrăm datele și care sunt temeiurile de
          prelucrare
        </SectionTitle>
        <Paragraph>
          Datele dumneavoastră cu Caracter Personal furnizate cu ocazia
          utilizării Website-ului, cum ar fi în contextul plasării de comenzi
          online; transmiterea de comenzi sau alte cereri pe e-mail; solicitarea
          de oferte; îmbunătăţirea serviciilor, sau furnizate în alt mod prin
          utilizarea Website-ului, ori în cadrul relației cu Ahava Cakes, pot fi
          prelucrate direct de Ahava Cakes şi/sau prin intermediul
          împuterniciţilor săi, în baza următoarelor scopuri şi temeiuri:
        </Paragraph>

        <Paragraph>
          <strong>
            III.1. În cazul în care sunteţi Utilizator al Website-ului
          </strong>
          , Datele dumneavoastră cu Caracter Personal sunt prelucrate după cum
          urmează:
        </Paragraph>

        <List>
          <ListItem>
            <strong>III.1.1.</strong> Pentru îmbunătățirea experienței
            dumneavoastră de navigare, dar și pentru a vă furniza serviciile
            solicitate, Website-ul nostru utilizează cookies.
            <br />
            <em>Temeiul prelucrării:</em> consimţământul, executarea
            contractului sau interesul legitim, conform prevederilor Legii
            506/2004 și celor detaliate în Politica de cookies.
          </ListItem>
          <ListItem>
            <strong>III.1.2.</strong> Pentru gestionarea cererilor transmise
            prin intermediul adreselor noastre de e-mail de pe Website.
            <br />
            <em>Temeiul prelucrării:</em> interes legitim.
          </ListItem>
        </List>

        <Paragraph>
          <strong>
            III.2. În cazul în care sunteți Client persoană fizică
          </strong>{" "}
          – atunci când plasați o comandă online pe Website-ul nostru, prin
          intermediul adreselor noastre de e-mail sau telefonic, datele
          dumneavoastră cu Caracter Personal sunt prelucrate după cum urmează:
        </Paragraph>

        <List>
          <ListItem>
            <strong>III.2.1.</strong> Pentru respectarea obligaţiilor legale
            (obligaţie legală): îndeplinirea obligaţiilor financiar-contabile şi
            fiscale; soluţionarea cererilor; audit intern; arhivare; gestionarea
            relațiilor cu autorități.
          </ListItem>
          <ListItem>
            <strong>III.2.2.</strong> Pentru încheierea și executarea
            contractelor (contract): procesarea comenzilor (preluare, validare,
            facturare, înmânare); informarea asupra stării comenzii; gestionarea
            conturilor; gestionarea cererilor/reclamaţiilor.
          </ListItem>
          <ListItem>
            <strong>III.2.3.</strong> Pentru îndeplinirea intereselor legitime
            (interes legitim): constatarea/exercitarea/apărarea drepturilor;
            analize, raportări, profiluri de preferinţe (în principal pentru
            îmbunătățiri); gestionarea altor cereri/reclamaţii.
          </ListItem>
          <ListItem>
            <strong>III.2.4.</strong> Marketing direct (consimţământ): acordul
            poate fi retras oricând; retragerea produce efecte numai pentru
            viitor.
          </ListItem>
        </List>

        <Paragraph>
          <strong>III.3.</strong> În cazul în care sunteţi persoană de contact a
          Clienților persoane juridice, vom putea prelucra datele dumneavoastră
          pentru obligații legale și interes legitim (ex. procesarea comenzilor,
          gestionarea cererilor).
        </Paragraph>

        <SectionTitle>IV. Ce date prelucrăm</SectionTitle>
        <Paragraph>
          Categoriile de Date cu Caracter Personal pe care le prelucrăm depind
          de interacțiunea dumneavoastră cu Website-ul nostru şi de raporturile
          create cu Titularul. Astfel, Ahava Cakes ar putea prelucra următoarele
          Categorii de Date cu Caracter Personal:
        </Paragraph>
        <List>
          <ListItem>
            pentru crearea conturilor online: nume, prenume, adresă de e-mail,
            număr de telefon;
          </ListItem>
          <ListItem>
            pentru comenzile online sau pe e-mail: nume, prenume, adresă de
            e-mail, număr de telefon;
          </ListItem>
          <ListItem>
            pentru comenzile telefonice: nume, prenume, număr de telefon;
          </ListItem>
          <ListItem>
            pentru transmiterea de comunicări comerciale: nume, prenume, adresă
            de e-mail;
          </ListItem>
          <ListItem>
            orice alte categorii de Date cu Caracter Personal pe care ni le veți
            furniza în mod direct în raport de scopul urmărit.
          </ListItem>
        </List>

        <SectionTitle>V. Către cine pot fi dezvăluite datele</SectionTitle>
        <Paragraph>
          Pentru îndeplinirea scopurilor de prelucrare, Ahava Cakes poate să
          dezvăluie anumite categorii de Date cu Caracter Personal către
          destinatari precum: procesatori de plăți, consultanţi externi
          (contabilitate, juridic, fiscal), parteneri pentru
          mentenanță/analize/rapoarte statistice, furnizori de comunicări de
          marketing (în condițiile legii), autorităţi publice (în baza
          obligațiilor legale) sau terţe părţi în contextul unor operațiuni
          corporative (fuziune, vânzare active etc.).
        </Paragraph>

        <SectionTitle>VI. Pe ce durată păstrăm datele</SectionTitle>
        <Paragraph>
          Ahava Cakes va prelucra Datele dumneavoastră cu Caracter Personal pe
          durata necesară realizării scopurilor de prelucrare și ulterior în
          conformitate cu politicile interne și obligațiile legale aplicabile,
          inclusiv termenele de arhivare/financiar-contabile (de exemplu, 10 ani
          pentru documente justificative financiar-contabile). Datele pentru
          marketing direct sunt prelucrate cât timp există consimţământ și
          ulterior pentru perioada necesară demonstrării conformării (de ex., 3
          ani).
        </Paragraph>

        <SectionTitle>
          VII. Transferul Datelor cu Caracter Personal
        </SectionTitle>
        <Paragraph>
          Datele cu Caracter Personal furnizate către Ahava Cakes nu vor fi
          transferate în afara României și, prin urmare, nici către state din
          afara Spaţiului Economic European.
        </Paragraph>

        <SectionTitle>
          VIII. Furnizarea Datelor cu Caracter Personal
        </SectionTitle>
        <Paragraph>
          Furnizarea datelor solicitate este necesară pentru înregistrarea și
          procesarea comenzilor și pentru emiterea facturilor. Refuzul
          furnizării poate duce la imposibilitatea de a înregistra comanda sau
          de a emite documentele fiscale. Pentru marketing direct, furnizarea
          datelor este voluntară.
        </Paragraph>

        <SectionTitle>
          IX. Securitatea Datelor cu Caracter Personal
        </SectionTitle>
        <Paragraph>
          Ahava Cakes implementează măsuri tehnice şi organizatorice adecvate
          pentru a asigura un nivel de securitate corespunzător riscurilor
          asociate prelucrării datelor.
        </Paragraph>

        <SectionTitle>
          X. Prelucrarea Datelor aparținând unor terțe persoane
        </SectionTitle>
        <Paragraph>
          Dacă ne indicați datele unor terțe persoane pentru ridicarea
          comenzilor, sunteți responsabil de informarea acestora cu privire la
          prelucrare și drepturile de care beneficiază.
        </Paragraph>

        <SectionTitle>XI. Drepturile dumneavostră</SectionTitle>
        <Paragraph>
          Beneficiați de drepturi precum: informare, acces, rectificare,
          ștergere (în condiții legale), restricționare, portabilitate,
          opoziție, a nu fi supus unei decizii automate, depunerea unei plângeri
          la autoritatea competentă și retragerea consimţământului (unde este
          cazul).
        </Paragraph>

        <Paragraph>
          Pentru exercitarea drepturilor și pentru mai multe informații, ne
          puteți contacta la <strong>office@ahavacakes.ro</strong> și/sau{" "}
          <strong>comenzi@ahavacakes.ro</strong>, telefon{" "}
          <strong>0775 107 107</strong> sau în scris la adresa:{" "}
          <strong>
            Arad, str. Elena Ghiba Birta nr 6-8, apartament 6, Demisol, jud.
            Arad
          </strong>
          .
        </Paragraph>

        <Divider />

        {/* ===================== */}
        {/* POLITICA COOKIES       */}
        {/* ===================== */}
        <Title>Politica de Cookies</Title>
        <Ornament>
          <OrnLine />
          <OrnDiamond />
        </Ornament>

        <Paragraph>
          Document de informare a utilizatorilor despre prezența cookie-urilor
          pe site-ul web <strong>www.ahavacakes.ro</strong>. Informațiile
          prezentate în continuare au scopul de a aduce la cunoștința
          utilizatorului mai multe detalii despre plasarea, utilizarea și
          administrarea cookie-urilor utilizate de site.
        </Paragraph>

        <SectionTitle>Ce este un cookie?</SectionTitle>
        <Paragraph>
          Un cookie este un fișier text care conține informații descărcate pe
          dispozitivul dumneavoastră atunci când vizitați (pentru prima dată) un
          site web. Acel cookie este trimis înapoi la fiecare vizită ulterioară
          către site-ul web de origine sau către alt site web care îl
          recunoaște. Cookie-urile sunt utile deoarece permit unui site web să
          recunoască un dispozitiv și vă oferă o experiență mai eficientă și
          personalizată.
        </Paragraph>

        <SectionTitle>Ce nu este un cookie?</SectionTitle>
        <Paragraph>
          Cookie-urile <strong>NU</strong> sunt viruși. Ele folosesc formate tip
          plain text. Nu sunt alcătuite din bucăți de cod, așa că nu pot fi
          executate și nici nu pot auto-rula. În consecință, nu se pot duplica
          sau replica pe alte rețele pentru a se rula sau replica din nou.
        </Paragraph>

        <SectionTitle>Ce tipuri de cookie sunt utilizate?</SectionTitle>
        <Paragraph>
          <strong>www.ahavacakes.ro</strong> folosește pe site-urile sale atât
          cookie-uri proprietare cât și cookie-uri terțe.
        </Paragraph>

        <Paragraph>
          <strong>Cookie-uri proprietare</strong> – utilizate de
          www.ahavacakes.ro când vizitați unul dintre site-urile noastre web și
          sunt de următoarele tipuri:
        </Paragraph>
        <List>
          <ListItem>
            <strong>tehnice</strong> – esențiale pentru funcționarea corectă a
            site-ului web; permit navigarea între secțiuni și folosirea
            funcțiilor specifice;
          </ListItem>
          <ListItem>
            <strong>de sesiune</strong> – temporare; permit navigare simplă și
            rapidă;
          </ListItem>
          <ListItem>
            <strong>persistente / de urmărire</strong> – durează mai multe
            sesiuni și rămân în browser o perioadă de timp după încheierea
            sesiunii (dacă nu le ștergeți);
          </ListItem>
          <ListItem>
            <strong>funcționale</strong> – monitorizează funcționarea corectă și
            rețin opțiuni (limba, numele de utilizator sau regiunea).
          </ListItem>
        </List>

        <Paragraph>
          <strong>Cookie-uri terțe</strong> – utilizate când vizitați site-ul
          nostru și sunt de următoarele tipuri:
        </Paragraph>
        <List>
          <ListItem>
            <strong>Cookie-uri de performanță (Google Analytics)</strong> –
            colectează informații anonime și centralizate despre comportamentul
            online (tip browser, IP, sistem de operare etc.) în scopuri
            statistice și pentru generarea profilurilor vizitatorilor.
          </ListItem>
        </List>

        <Paragraph>
          Cookie-urile pe care la folosim noi nu colectează date care să vă
          dezvăluie identitatea și, de aceea, nu vă putem identifica cu ajutorul
          lor. Site-ul nostru web poate conține link-uri către alte site-uri web
          care nu sunt deținute/administrate de www.ahavacakes.ro (conținut
          terț, linkuri și plug-in-uri). www.ahavacakes.ro nu își asumă
          responsabilitatea pentru practicile de confidențialitate aplicate de
          aceste site-uri web.
        </Paragraph>

        <SectionTitle>Cum vă exprimați acordul?</SectionTitle>
        <Paragraph>
          Când vizitați pentru prima dată site-ul nostru, în partea de jos a
          ecranului este afișat un banner cu un mesaj despre cookie. Dacă dați
          click pe butonul de confirmare din popup-ul care apare cand vizitati
          site-ul sau prin continuarea navigarii, atunci vă exprimați acordul
          implicit pentru utilizarea cookie-urilor conform prezentei politici,
          cu excepția cazului în care v-ați setat browserul astfel încât să
          respingă cookie-urile.
        </Paragraph>

        <SectionTitle>Cum respingeți cookie-urile?</SectionTitle>
        <Paragraph>
          Puteți să vă retrageți în orice moment acordul ștergând cookie-urile
          din browser. Aceste setări se găsesc de obicei în meniul ‘opțiuni’ sau
          ‘preferințe’ din browser. Pentru a înțelege aceste setări, accesați
          opțiunea ‘Ajutor’ din browser pentru mai multe detalii.
        </Paragraph>
      </Modal>
    </Overlay>
  );
}
